<div class="summary-header">
  <div class="summary-searchbar"><app-searchbar [setPlaceholder]="summaryName" [keyword]="keyword" (keywordChanged)="keyword=$event" [hidden]="hidePanel" [enableSearch]="enableSearch"></app-searchbar></div>
  <div class="summary-input-combo" *ngIf="showInputCombo"><app-input-combo (selectedComboIdChanged)="customInput=$event" [inputComboFilter]="inputComboFilter"></app-input-combo></div>
</div>
<div class="summary-main-container" [class.hide]="hidePanel">
  <div class="sort-container">
    <div *ngIf="isDualView" class="dual-view-container">
      <p style="font-size: 13px;float:left;margin-top: 4px;margin-right: 4px;">View : </p>
      <a class="view-ic card-view-ic" (click)="changeLayout(true, 1)" [class.disabled]="fetching" matTooltip="Card view"><mat-icon class="dual-icon" [class.active]="isCardView">apps</mat-icon></a>
      <a class="view-ic table-view-ic" (click)="changeLayout(false, 2)" [class.disabled]="fetching" matTooltip="Table view"><mat-icon class="dual-icon" [class.active]="!isCardView">view_list</mat-icon></a>
    </div>
      <ng-select class="dropdown-ng-select no-border sort-dropdown"
      id="sort-dropdown"
      (change)="onFilterChanged($event)" 
      [clearable]="false" 
      [searchable]="false"
      [(ngModel)]="selectedSortValue" 
      placeholder="Please Select">
      <ng-option *ngFor="let sortOption of sortOptions" [value]="sortOption.SortField" >{{sortOption.SortOptionDisplay}}</ng-option>
      </ng-select>
    <p id="sortOrder">
      <span class="sort-order-text" id="sortOrderText" (click)="onChangeSortDirection()">{{ sortOrder }}</span>
    </p>
    <div *ngIf="selectedSortValue" class="summary-menu" title="View options" (click)="onContextMenu($event)"><mat-icon>menu</mat-icon></div>
    <div class="filter-case">
      <app-filteroption [componentId]="componentId" (refreshSummary)="forceSummaryRefresh($event)"></app-filteroption>
    </div>
    <div class="clearfix"></div>
  </div>
  <div class="sc-divider"></div>
  <app-sub-summary #subsummary [componentIdSet]="componentId" [setSelectedDetailId]='selectedItemId' (subSelectedId)='onSelectedItem($event)' (subSelectedType)='onSelectedType($event)' 
    [setSearchKeyword]="keyword" (sortOptions)="onSearchOptionsChange($event)" [changeSortOption]="selectedSortOption" [changeSortDirection]="sortDirectionIsAscending" 
    [setPageSize]="pageSize" (summaryPage)="onSummaryPageChange($event)" (summaryTotalRows)="onSummaryTotalRowsChange($event)"
    [prevPageTrigger]="prevPageDummy" [nextPageTrigger]="nextPageDummy" [setForceRefresh]="forceRefresh" [changePageTrigger]="currentPageChange" (updateParent)="updateParentControl($event)" 
    (subCardSelectedId)="onSelectedCardId($event)" (setSummaryName)="setSummary($event)" (isCardImage)="showInputCombo=$event"
    [customInputSet]="customInput" (isDualView)="isDualView = $event" (isCardView)="isCardView = $event" [changeLayout]="changeSummaryLayout" (fetching)="fetching = $event">
  </app-sub-summary>
  
  <context-menu [useBootstrap4]="true">
    <ng-template contextMenuItem (execute)="saveSetting()">
      Save as my default
    </ng-template>
  </context-menu>
  <!-- <div *ngIf="showPagination" class="mb-pagination-container">
    <div style="padding: 0 15px;">
      <label style="float:left;padding-top: 7px;font-size: 12px;padding-right: 5px">Results : </label>
      <ng-select class="dropdown-ng-select paginate" (change)="changePagingSize($event)" [clearable]="false" [(ngModel)]="selectedResult" [searchable]="false" placeholder="Please Select" dropdownPosition="top">
        <ng-option class="dropdown-item-results" value="10">10 per page</ng-option>
        <ng-option class="dropdown-item-results" value="20">20 per page</ng-option>
        <ng-option clasadasdasds="dropdown-item-results" value="30">30 per page</ng-option>
      </ng-select>
    </div>
    <div class="pagination-container" style="font-size: 0.75em">
      <!-- <ul class="pagination cust-pagination" id="pagination" style="float:right;">
        <li class="page-item prev-case" *ngIf="currentPage != 1">
          <a class="page-link btn-page-prev" (click)="previousPage()"><span><i class="glyphicon glyphicon-triangle-left" style="padding-right:10px;"></i></span>Previous</a>
        </li>
        <li class="page-item forward-case" *ngIf="currentPage != availablePages">
          <a class="page-link btn-page-next" (click)="nextPage()">
            Next<span style="border: none;margin-left: 0px;">
            <i class="glyphicon glyphicon-triangle-right" style="padding-left:10px;"></i>
          </span>
          </a>
        </li>
      </ul> 
      <ul class="pagination cust-pagination" style="float:right;">
        <li class="page-item prev-case">
          <button [disabled]="currentPage == 1" [hidden]="availablePages == 1"
          [ngClass]="{'page-link btn-page-prev': true, 'disabled' : currentPage == 1 }" 
          (click)="previousPage()">
            <span><fa name="caret-left" size="lg"></fa></span>
            Previous
          </button>
        </li>
        <li *ngFor="let page of rangeWithDots" class="page-item">
          <a [ngClass]="{'page-link': true, 'active': page == currentPage, 'dots': page == '...'}" (click)="onCurrentPageChange(page)">{{ page }}</a>
        </li>
        <li class="page-item forward-case">
          <button [disabled]="currentPage == availablePages" [hidden]="availablePages == 1"
          [ngClass]="{'page-link btn-page-next': true, 'disabled': currentPage == availablePages }" 
          (click)="nextPage();">Next
              <fa name="caret-right" size="lg"></fa>
          </button>
        </li>
      </ul>
    </div>
  </div>
</div> -->